// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import InvestorEnquiryManagerPage from "../../components/dashboard/InvestorEnquiryManagerPage";

export default function InvestorEnquiryManager() {
  return (
    <DashboardLayout>
      <InvestorEnquiryManagerPage />
    </DashboardLayout>
  );
}
